"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

//Libraries
//Material-ui
var styles = function styles(theme) {
  return {
    root: {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
      textAlign: 'right',
      width: '100%'
    },
    secondary: {
      marginRight: theme.spacing(1)
    }
  };
};

var Actions = function Actions(_ref) {
  var classes = _ref.classes,
      color = _ref.color,
      primaryAction = _ref.primaryAction,
      primaryLabel = _ref.primaryLabel,
      secondaryAction = _ref.secondaryAction,
      secondaryLabel = _ref.secondaryLabel;
  return _react["default"].createElement("div", {
    className: classes.root
  }, secondaryAction ? _react["default"].createElement(_Button["default"], {
    className: classes.secondary,
    color: color,
    onClick: secondaryAction
  }, secondaryLabel) : null, _react["default"].createElement(_Button["default"], {
    variant: "contained",
    color: color,
    onClick: primaryAction
  }, primaryLabel));
};

var _default = (0, _styles.withStyles)(styles, {
  withTheme: true
})(Actions);

exports["default"] = _default;